"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgChartBreakoutCircle = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12 1C5.925 1 1 5.925 1 12c0 .1 0 .149.01.22.046.316.296.646.59.774.065.028.123.044.239.076.181.05.345.094.481.13.861.196 1.758.3 2.68.3 3.306 0 6.3-1.336 8.47-3.5H12a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-1.702a13.96 13.96 0 0 1-10.777 4.181c-1.012-.055-1.518-.082-1.797.107a1.02 1.02 0 0 0-.433.717c-.037.335.16.666.555 1.328A10.994 10.994 0 0 0 12 23c6.075 0 11-4.925 11-11S18.075 1 12 1Z", fill: "currentColor" }) }))); };
exports.default = SvgChartBreakoutCircle;
